import { CloudUploadOutlined } from '@mui/icons-material';
import * as Sentry from '@sentry/react';
import { useAlert } from 'components/UI/alertSakeBar/alertProvider';
import React, { useEffect, useState } from 'react';
import { FileUploader } from "react-drag-drop-files";
import styled from 'styled-components';
import COLOR from "utils/constants/color";
import { IMAGE_FILE_TYPE, UPLOAD_IMAGE_TO_FIREBASE } from 'utils/constants/enum';
import { imageUploader } from 'utils/methods/imageUploader';



const ImageContainer = styled.div`
    height: auto;
    flex: 1;
    height:70vh;
`;

const Images = styled.img`
    background-color: ${COLOR.white};
    box-shadow: 0 10px 20px rgba(0,0,0,0.19), 0 6px 6px rgba(0,0,0,0.23);
    max-height: 100%;
    max-width: 100%;
    object-fit: contain;
    border-radius:8px;
    background-color:#000000;
`;
const Container = styled.div`
    width: 200px;
    height: 100px;
    display:flex;
    align-item:center;
    justify-content:center;
    position: relative;
    background-color:${p => p.empty ? "rgba(0,0,0,0.1)" : "transparent"}
`;

;


const FileUploadArea = styled.div`
    height: 100%;
    padding: 5px 12px;
    min-height: 50px;
    display: flex;
    flex-direction: column;
    justify-content: center;
`;


const PercentArea = styled.span`
  color: #03989e;
  font-size: 11px;
  font-weight: 600;
`
export default function LogoUploader({ src, onChange,  style }) {
    const showAlert = useAlert();
    const [pagePoster, setpagePoster] = useState(src)
    const [loader, setLoader] = useState(false)
    const [loadingMap, setLoadingMap] = useState(0)


    useEffect(() => {
        setpagePoster(src)
    }, [src])
    const handleChange = (file) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        uploadToStorage(file, '')
        reader.onloadend = function (e) {
            let v = reader.result;
            setpagePoster(v)
        };
    };
    const uploadToStorage = async (file, index) => {
        if (file) {
            try {
                setLoader(true);
                const onProgress = per=>{
                    setLoadingMap(per);
                    setLoader(true);
                }               
                const download_url = await imageUploader(file, onProgress,UPLOAD_IMAGE_TO_FIREBASE)
                if (download_url) {
                    onChange(download_url);
                } else {
                    showAlert("Unable to upload image.","error")
                }
            } catch (error) {
                console.error("Upload error:", error);
                Sentry.captureException(`380 Error during uploadToStorage: ${error}`);
                showAlert("Unable to upload image.","error")
            } finally {
                setLoader(false);
                setLoadingMap(0);
            }
        } else {
            console.log("No file to upload.");
        }
    };
   
    return (
        <ImageContainer onContextMenu={(e) => { }} style={style}>
            <Container empty={!pagePoster} >
                <Images src={pagePoster} className={"cursor-zoomIn"} />
                <FileUploader
                    classes={"file-uploader-district-logo"}
                    style={{ marginTop:"25%" , width:"40%" , borderRadious:"10px" }}
                    handleChange={handleChange}
                    name="file"
                    types={IMAGE_FILE_TYPE}

                >
                    <FileUploadArea>
                        <CloudUploadOutlined style={{ color: "#000", fontSize: "24px" }} />
                        {loader && loadingMap < 100 && (
                            <PercentArea>{loadingMap + "%"}</PercentArea>
                        )}
                    </FileUploadArea>
                </FileUploader>
            </Container>
        </ImageContainer>
    )
}
